export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-clapperboard-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  description: string;
  lastUpdated: string;
  tags: string[];
  chapters: { id: number; title: string; date: string }[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20cover%20art%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%2C%20dramatic%20lighting%2C%20action%20pose%2C%20manga%20illustration%20style%2C%20cool%20purple%20and%20black%20tones%2C%20clean%20background%20with%20subtle%20magic%20effects&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    rating: 4.9,
    views: '1280万',
    description: '十多年前，世界各地突然出现连接异次元与现实的"传送门"，而在这其中觉醒的人类被称为"猎人"。成振宇，人类最弱猎人，在一次双重地下城任务中濒临死亡，却意外获得了"系统"的能力，开启了成为世界最强猎人的传奇之路。',
    lastUpdated: '2026-08-03',
    tags: ['系统', '升级', '战斗', '热血'],
    chapters: [
      { id: 200, title: '第200话 - 最终决战（三）', date: '2026-08-03' },
      { id: 199, title: '第199话 - 最终决战（二）', date: '2026-07-27' },
      { id: 198, title: '第198话 - 最终决战（一）', date: '2026-07-20' },
      { id: 197, title: '第197话 - 君主的觉醒', date: '2026-07-13' },
      { id: 196, title: '第196话 - 最后的考验', date: '2026-07-06' },
    ],
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20soft%20pastel%20colors%2C%20school%20romance%20theme%2C%20delicate%20illustration%20style%2C%20shojo%20manga%20aesthetic%2C%20clean%20light%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: 'romance',
    status: '已完结',
    rating: 4.8,
    views: '2560万',
    description: '因为外貌丑陋而被欺负的任朱静，通过化妆技巧成功逆袭成为校园女神。然而，她必须隐藏自己素颜的秘密，在两个完美男神之间周旋，展开了一段笑中带泪的校园恋爱故事。',
    lastUpdated: '2026-06-15',
    tags: ['校园', '恋爱', '逆袭', '化妆'],
    chapters: [
      { id: 250, title: '第250话 - 最终话：永远的女神', date: '2026-06-15' },
      { id: 249, title: '第249话 - 告白', date: '2026-06-08' },
      { id: 248, title: '第248话 - 选择', date: '2026-06-01' },
      { id: 247, title: '第247话 - 真心', date: '2026-05-25' },
      { id: 246, title: '第246话 - 误会解除', date: '2026-05-18' },
    ],
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalyptic%20fantasy%20cover%2C%20male%20protagonist%20reading%20a%20book%20in%20destroyed%20city%2C%20dramatic%20cinematic%20lighting%2C%20action%20fantasy%20illustration%2C%20webtoon%20style%20art%2C%20intense%20atmosphere&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    rating: 4.9,
    views: '1980万',
    description: '金独子是唯一读完了连载十年的网络小说《在灭亡世界生存的三种方法》的读者。当小说最后一章更新时，小说中的世界竟然变成了现实，而只有他知道这个世界将会如何发展。',
    lastUpdated: '2026-08-02',
    tags: ['末世', '系统', '生存', '小说变现实'],
    chapters: [
      { id: 180, title: '第180话 - 星流的真相', date: '2026-08-02' },
      { id: 179, title: '第179话 - 最后的故事', date: '2026-07-26' },
      { id: 178, title: '第178话 - 星座之战', date: '2026-07-19' },
      { id: 177, title: '第177话 - 回归者的秘密', date: '2026-07-12' },
      { id: 176, title: '第176话 - 新的同伴', date: '2026-07-05' },
    ],
  },
  {
    id: 4,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20action%20cover%2C%20two%20different%20bodies%20of%20same%20person%2C%20handsome%20and%20ugly%20contrast%2C%20fighting%20scene%2C%20dramatic%20webtoon%20style%2C%20dark%20school%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: 'action',
    status: '连载中',
    rating: 4.7,
    views: '3120万',
    description: '被霸凌的胖学生朴亨锡，某天醒来发现自己拥有了一个完美的身体。白天他是帅气完美的男神，晚上则变回原本的模样。两个身体让他看到了这个世界截然不同的两面。',
    lastUpdated: '2026-08-01',
    tags: ['校园', '双面人生', '格斗', '社会'],
    chapters: [
      { id: 420, title: '第420话 - 四大联盟', date: '2026-08-01' },
      { id: 419, title: '第419话 - 一线天', date: '2026-07-25' },
      { id: 418, title: '第418话 - 打工王', date: '2026-07-18' },
      { id: 417, title: '第417话 - 俊九的过去', date: '2026-07-11' },
      { id: 416, title: '第416话 - 新对手', date: '2026-07-04' },
    ],
  },
  {
    id: 5,
    title: '甜蜜的家庭',
    author: '金坎比 / 黄英灿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20cover%2C%20monster%20transformation%2C%20apartment%20building%20background%2C%20dark%20atmosphere%2C%20survival%20horror%20style%2C%20intense%20manga%20illustration%2C%20clean%20dark%20background&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: 'thriller',
    status: '已完结',
    rating: 4.8,
    views: '1850万',
    description: '因为受到校园霸凌而封闭自我的车贤秀，在失去所有家人后搬到了一栋破旧的公寓。然而，一种神秘的怪物化现象开始在世界蔓延，人们会因为内心的欲望而变成怪物。贤秀必须在这个疯狂的世界中活下去。',
    lastUpdated: '2026-05-20',
    tags: ['怪物', '生存', '末世', '心理'],
    chapters: [
      { id: 140, title: '第140话 - 最终话：甜蜜的家', date: '2026-05-20' },
      { id: 139, title: '第139话 - 最后的怪物', date: '2026-05-13' },
      { id: 138, title: '第138话 - 觉醒', date: '2026-05-06' },
      { id: 137, title: '第137话 - 特殊感染者', date: '2026-04-29' },
      { id: 136, title: '第136话 - 绿色家园', date: '2026-04-22' },
    ],
  },
  {
    id: 6,
    title: '外貌至上主义',
    author: '金熙珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20school%20cover%2C%20funny%20expression%20characters%2C%20bright%20colorful%20school%20setting%2C%20humor%20webtoon%20style%2C%20playful%20illustration%2C%20clean%20light%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: 'comedy',
    status: '连载中',
    rating: 4.6,
    views: '920万',
    description: '在一个人人看脸的世界里，长相平凡的姜斗植决定用自己的方式反击。他创立了"外貌至上主义"组织，却发现这个世界对外貌的执着远超他的想象，各种爆笑事件接踵而至。',
    lastUpdated: '2026-07-30',
    tags: ['搞笑', '校园', '社会讽刺', '日常'],
    chapters: [
      { id: 95, title: '第95话 - 选美比赛', date: '2026-07-30' },
      { id: 94, title: '第94话 - 整容风波', date: '2026-07-23' },
      { id: 93, title: '第93话 - 外貌分数', date: '2026-07-16' },
      { id: 92, title: '第92话 - 相亲大作战', date: '2026-07-09' },
      { id: 91, title: '第91话 - 颜值即正义', date: '2026-07-02' },
    ],
  },
  {
    id: 7,
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20office%20cover%2C%20elegant%20woman%20in%20art%20gallery%2C%20romantic%20atmosphere%2C%20soft%20warm%20tones%2C%20adult%20romance%20illustration%2C%20clean%20gallery%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: 'romance',
    status: '已完结',
    rating: 4.7,
    views: '1560万',
    description: '美术馆首席策展人成德美，表面上是一位专业干练的职场女性。但她有一个不为人知的秘密——她是一个狂热的偶像粉丝。当新馆长莱恩·金发现了她的秘密后，两人之间展开了一段非比寻常的浪漫故事。',
    lastUpdated: '2026-04-10',
    tags: ['职场', '恋爱', '追星', '秘密'],
    chapters: [
      { id: 120, title: '第120话 - 最终话：我们的私生活', date: '2026-04-10' },
      { id: 119, title: '第119话 - 公开', date: '2026-04-03' },
      { id: 118, title: '第118话 - 他的秘密', date: '2026-03-27' },
      { id: 117, title: '第117话 - 危机', date: '2026-03-20' },
      { id: 116, title: '第116话 - 约会', date: '2026-03-13' },
    ],
  },
  {
    id: 8,
    title: '剑尊归来',
    author: '柳成贤 / 李贤民',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%2C%20swordsman%20in%20traditional%20clothing%2C%20ancient%20Chinese%20style%20palace%20background%2C%20murim%20wuxia%20illustration%2C%20dramatic%20action%20pose%2C%20clean%20background%20with%20cherry%20blossoms&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: 'historical',
    status: '连载中',
    rating: 4.9,
    views: '2320万',
    description: '天下第一剑——青云剑尊陈海元，在与魔教教主的大战之后意外穿越到现代。在这个陌生的世界里，他发现武道已经没落，而他的剑术在这个时代依然无敌。曾经的第一剑尊，在现代开始了新的传说。',
    lastUpdated: '2026-08-03',
    tags: ['武侠', '穿越', '江湖', '热血'],
    chapters: [
      { id: 155, title: '第155话 - 现代武林盟', date: '2026-08-03' },
      { id: 154, title: '第154话 - 剑道大会', date: '2026-07-27' },
      { id: 153, title: '第153话 - 旧敌', date: '2026-07-20' },
      { id: 152, title: '第152话 - 收徒', date: '2026-07-13' },
      { id: 151, title: '第151话 - 青云剑法', date: '2026-07-06' },
    ],
  },
  {
    id: 9,
    title: '便利店新星',
    author: '活跃火山',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20convenience%20store%20setting%2C%20young%20couple%20working%20together%2C%20warm%20daily%20life%20illustration%2C%20cozy%20night%20atmosphere%2C%20clean%20store%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    category: 'daily',
    status: '已完结',
    rating: 4.5,
    views: '870万',
    description: '便利店店长崔大贤是一个老实本分的普通青年，直到有一天，一个曾经的不良少女丁新星来店里打工。她的出现彻底打乱了大贤平静的生活，也为他带来了意想不到的温暖与改变。',
    lastUpdated: '2026-03-28',
    tags: ['日常', '恋爱', '治愈', '职场'],
    chapters: [
      { id: 88, title: '第88话 - 最终话：一直在这里', date: '2026-03-28' },
      { id: 87, title: '第87话 - 新星的决心', date: '2026-03-21' },
      { id: 86, title: '第86话 - 大贤的选择', date: '2026-03-14' },
      { id: 85, title: '第85话 - 重新开始', date: '2026-03-07' },
      { id: 84, title: '第84话 - 离开', date: '2026-02-28' },
    ],
  },
  {
    id: 10,
    title: '鬼传',
    author: '金成圭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20ghost%20cover%2C%20supernatural%20entity%20in%20dark%20alley%2C%20eerie%20atmosphere%2C%20cold%20blue%20tones%2C%20ghost%20story%20illustration%2C%20clean%20dark%20background%20with%20fog&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    category: 'horror',
    status: '连载中',
    rating: 4.6,
    views: '680万',
    description: '能够看到鬼魂的大学生李贤宇，被卷入了一系列超自然事件中。每一个鬼魂都有未了的心愿，而贤宇是唯一能帮助它们的人。但随着他越深入这个世界，他发现了一个隐藏在鬼魂背后的惊天阴谋。',
    lastUpdated: '2026-07-28',
    tags: ['灵异', '悬疑', '都市传说', '惊悚'],
    chapters: [
      { id: 72, title: '第72话 - 红衣女鬼', date: '2026-07-28' },
      { id: 71, title: '第71话 - 旧教学楼', date: '2026-07-21' },
      { id: 70, title: '第70话 - 通灵者', date: '2026-07-14' },
      { id: 69, title: '第69话 - 附身', date: '2026-07-07' },
      { id: 68, title: '第68话 - 镜中人', date: '2026-06-30' },
    ],
  },
  {
    id: 11,
    title: '重生之都市仙尊',
    author: '狂笑的菠萝糖',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20cover%2C%20immortal%20cultivator%20in%20modern%20city%2C%20magical%20powers%20display%2C%20urban%20fantasy%20style%2C%20dramatic%20composition%2C%20clean%20city%20skyline%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    rating: 4.8,
    views: '3650万',
    description: '仙界第一仙尊陈凡，渡劫失败后重生回到地球的大学时代。曾经的遗憾、背叛与屈辱，这一世他要全部改写。拥有仙界记忆的他，在地球上开始了逆天改命的传奇之路。',
    lastUpdated: '2026-08-04',
    tags: ['重生', '修仙', '都市', '逆袭'],
    chapters: [
      { id: 310, title: '第310话 - 昆仑秘境', date: '2026-08-04' },
      { id: 309, title: '第309话 - 仙门来人', date: '2026-07-28' },
      { id: 308, title: '第308话 - 地球灵气复苏', date: '2026-07-21' },
      { id: 307, title: '第307话 - 海外仙山', date: '2026-07-14' },
      { id: 306, title: '第306话 - 炼丹大会', date: '2026-07-07' },
    ],
  },
  {
    id: 12,
    title: '我的ID是江南美人',
    author: '淇萌',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20college%20romance%20cover%2C%20beautiful%20girl%20with%20natural%20look%2C%20university%20campus%20setting%2C%20heartwarming%20romance%20illustration%2C%20soft%20pastel%20tones%2C%20clean%20bright%20background&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    category: 'drama',
    status: '已完结',
    rating: 4.7,
    views: '1980万',
    description: '姜美来因为长相平凡从小被嘲笑，她决定在进入大学前进行整容手术。然而，成为"江南美人"后的校园生活并非她想象的那般美好。她遇到了知道她过去的都炅锡，一段关于自尊、成长与真爱的故事就此展开。',
    lastUpdated: '2026-02-14',
    tags: ['校园', '整容', '成长', '恋爱'],
    chapters: [
      { id: 100, title: '第100话 - 最终话：真正的美', date: '2026-02-14' },
      { id: 99, title: '第99话 - 接纳自我', date: '2026-02-07' },
      { id: 98, title: '第98话 - 炅锡的故事', date: '2026-01-31' },
      { id: 97, title: '第97话 - 真相', date: '2026-01-24' },
      { id: 96, title: '第96话 - 她的选择', date: '2026-01-17' },
    ],
  },
];

export const featuredComics = [1, 3, 8, 11];
export const latestComics = [11, 1, 3, 8, 4, 10, 6, 2];
export const rankingComics = [11, 4, 3, 1, 8, 2, 5, 7, 12, 9];